import { render, staticRenderFns } from "./thirdPayResult.vue?vue&type=template&id=91ff5b4e&scoped=true"
import script from "./thirdPayResult.vue?vue&type=script&lang=js"
export * from "./thirdPayResult.vue?vue&type=script&lang=js"
import style0 from "./thirdPayResult.vue?vue&type=style&index=0&id=91ff5b4e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91ff5b4e",
  null
  
)

export default component.exports